var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0607 0.93934C25.6464 1.52513 25.6464 2.47487 25.0607 3.06066L11.0607 17.0607C10.4749 17.6464 9.52513 17.6464 8.93934 17.0607L0.93934 9.06066C0.353553 8.47487 0.353553 7.52513 0.93934 6.93934C1.52513 6.35355 2.47487 6.35355 3.06066 6.93934L10 13.8787L22.9393 0.93934C23.5251 0.353553 24.4749 0.353553 25.0607 0.93934Z",
    fill: "#242833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.cba71d64b8b2e88fabac968412b536d2.svg";
export { ForwardRef as ReactComponent };